import { render, staticRenderFns } from "./TokenRight.vue?vue&type=template&id=7ef8c448&"
import script from "./TokenRight.vue?vue&type=script&lang=ts&"
export * from "./TokenRight.vue?vue&type=script&lang=ts&"
import style0 from "./TokenRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports